import { useStateQuery } from '../api/state';
import { BackLink } from '../components/layout/BackLink';
import { SettingsControls } from '../components/SettingsControls';
import { SchedulesSection } from '../components/schedule/SchedulesSection';

export function SettingsPage() {
  const { data } = useStateQuery();

  return (
    <>
      <BackLink />
      <h1>Settings</h1>

      <h2>Temperature &amp; zones</h2>
      {data && (
        <SettingsControls
          setpoint={data.setpoint_c}
          wpmOffset={data.wpm_offset_c}
          bypassGroup={data.bypass.group}
          weatherLocation={data.weather_location}
        />
      )}

      <h2>Schedules</h2>
      <SchedulesSection />
    </>
  );
}
